import { createContext } from 'react';
import { PluginProviderCtx } from '../types';

export const PluginContext = createContext<PluginProviderCtx | null>(null);
